// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"88":"login-page","141":"contacts-page","316":"register-page"}[chunkId] || chunkId) + "." + {"88":"6ba7732f","141":"14a7ca24","316":"0376be82","426":"8ca22e6b"}[chunkId] + ".chunk.js";
};